import { _ as __rest, a as __awaiter } from '../../tslib.es6-17e0406b.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Box, Grid, Card, CardHeader, Divider, CardContent, Button, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { Text } from './Input/Text.js';
import { Date } from './Input/Date.js';
import { Hour } from './Input/Hour.js';
import { Select } from './Input/Select.js';
import { Checkbox } from './Input/Checkbox.js';
import { Radio } from './Input/Radio.js';
import { Quantity } from './Input/Quantity.js';
import '../DatePicker.js';
import 'date-fns/locale/pt-BR';
import '@mui/x-date-pickers/AdapterDateFns';
import '@mui/x-date-pickers/LocalizationProvider';
import '@mui/x-date-pickers/DatePicker';
import '../HourPicker.js';
import '@mui/x-date-pickers/TimePicker';
import '../../utils/formatDate.js';
import 'react';
import '../QuantityInput.js';
import 'react-number-format';

const Quiz = (_a) => {
    var { quiz, setQuiz, saveQuiz } = _a, rest = __rest(_a, ["quiz", "setQuiz", "saveQuiz"]);
    const { enqueueSnackbar } = useSnackbar();
    const sessionAndIndex = (name) => {
        const index = { session: -1, question: -1 };
        quiz.Secoes.forEach((session, sessionIndex) => {
            const questionIndex = session.Perguntas.findIndex(p => p.OrdemPergunta === parseInt((name === null || name === void 0 ? void 0 : name.toString()) || '', 10));
            if (questionIndex >= 0) {
                index.session = sessionIndex;
                index.question = questionIndex;
            }
        });
        return index;
    };
    const handleChange = (event) => {
        const change = quiz;
        const index = sessionAndIndex(event.target.name);
        let parseValue = event.target.value;
        if (change.Secoes[index.session].Perguntas[index.question].RespostaTipo ===
            'N') {
            parseValue = Number(parseValue);
        }
        change.Secoes[index.session].Perguntas[index.question].Resposta = parseValue;
        setQuiz(Object.assign({}, change));
    };
    const handleChangeDate = (date, name) => {
        const change = quiz;
        const index = sessionAndIndex(name);
        change.Secoes[index.session].Perguntas[index.question].Resposta = moment(date).format('YYYY-MM-DDT00:00:00');
        setQuiz(Object.assign({}, change));
    };
    const handleChangeHour = (date, name) => {
        const change = quiz;
        const index = sessionAndIndex(name);
        change.Secoes[index.session].Perguntas[index.question].Resposta = moment(date).format('HHmm');
        setQuiz(Object.assign({}, change));
    };
    const handleChangeCheckbox = (event, checkboxValue) => {
        const change = quiz;
        const index = sessionAndIndex(event.target.name);
        const { RespostasMultiplas } = change.Secoes[index.session].Perguntas[index.question];
        if (RespostasMultiplas) {
            if (event.target.checked) {
                change.Secoes[index.session].Perguntas[index.question].Resposta.push(checkboxValue);
            }
            else {
                const answerIndex = change.Secoes[index.session].Perguntas[index.question].Resposta.findIndex((ele) => ele === checkboxValue);
                change.Secoes[index.session].Perguntas[index.question].Resposta.splice(answerIndex, 1);
            }
        }
        else {
            change.Secoes[index.session].Perguntas[index.question].Resposta =
                event.target.checked;
        }
        setQuiz(Object.assign({}, change));
    };
    const handleChangeQuantity = (event, value) => {
        const change = quiz;
        const index = sessionAndIndex(event.target.name);
        change.Secoes[index.session].Perguntas[index.question].Resposta = value;
        setQuiz(Object.assign({}, change));
    };
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        quiz.Secoes.forEach(session => {
            session.Perguntas.forEach(question => {
                if (question.RespostaObrigatoria) {
                    enqueueSnackbar(`O campo ${question.Titulo} é obrigatório`, {
                        variant: 'error',
                    });
                }
            });
        });
        try {
            const response = yield saveQuiz(quiz);
            if (!(response.messages instanceof Array)) {
                response.messages = [...response.messages];
            }
            response.messages.forEach((message) => enqueueSnackbar(message, {
                variant: 'success',
            }));
        }
        catch (err) {
            enqueueSnackbar(err, {
                variant: 'error',
            });
        }
    });
    return (jsxs(Box, Object.assign({}, rest, { children: [jsx(Grid, Object.assign({ container: true, spacing: 3 }, { children: quiz === null || quiz === void 0 ? void 0 : quiz.Secoes.map((session, sessionIndex) => {
                    return (jsx(Grid, Object.assign({ item: true, sm: 12, md: 12, lg: 12, xs: 12 }, { children: jsxs(Card, { children: [jsx(CardHeader, { title: session.Titulo }), jsx(Divider, {}), jsx(CardContent, { children: jsx(Grid, Object.assign({ container: true, spacing: 3 }, { children: session.Perguntas.map(question => {
                                            const { Titulo, CampoVisual, RespostaTipo, OrdemPergunta, RespostasPossiveis, Resposta, } = question;
                                            const { Inteiro, NumeroDecimal, } = question.MascaraRespostaResolvida;
                                            switch (true) {
                                                case CampoVisual === 'E' && RespostaTipo === 'D':
                                                    return (jsx(Date, { label: Titulo, value: Resposta, name: OrdemPergunta, handleChange: handleChangeDate }, OrdemPergunta));
                                                case CampoVisual === 'E' && RespostaTipo === 'H':
                                                    return (jsx(Hour, { label: Titulo, value: Resposta, name: OrdemPergunta, handleChange: handleChangeHour }, OrdemPergunta));
                                                case CampoVisual === 'E' &&
                                                    (RespostaTipo === 'V' || RespostaTipo === 'N'):
                                                    return (jsx(Quantity, { label: Titulo, value: Resposta, name: OrdemPergunta, handleChange: handleChangeQuantity, integer: Inteiro, decimal: NumeroDecimal }, OrdemPergunta));
                                                case CampoVisual.trim() === '' || CampoVisual === 'L':
                                                    return (jsx(Select, { label: Titulo, value: Resposta, options: RespostasPossiveis, name: OrdemPergunta, handleChange: handleChange }, OrdemPergunta));
                                                case CampoVisual === 'C':
                                                    return (jsx(Checkbox, { label: Titulo, value: Resposta, options: RespostasPossiveis, name: OrdemPergunta, handleChange: handleChangeCheckbox }, OrdemPergunta));
                                                case CampoVisual === 'R':
                                                    return (jsx(Radio, { label: Titulo, options: RespostasPossiveis, value: Resposta, name: OrdemPergunta, handleChange: handleChange }, OrdemPergunta));
                                                default:
                                                    return (jsx(Text, { label: Titulo, value: Resposta, name: OrdemPergunta, handleChange: handleChange }, OrdemPergunta));
                                            }
                                        }) })) })] }) }), `session-${sessionIndex}`));
                }) })), quiz && quiz.Secoes.length > 0 ? (jsx(Box, Object.assign({ mt: 3 }, { children: jsx(Button, Object.assign({ variant: "contained", onClick: handleSubmit }, { children: "Enviar" })) }))) : (jsx(Grid, Object.assign({ item: true, md: 12, sm: 12, xs: 12 }, { children: jsx(Grid, Object.assign({ container: true, justifyContent: "center", alignItems: "center" }, { children: jsx(Grid, Object.assign({ item: true }, { children: jsx(Box, Object.assign({ mt: 3 }, { children: jsx(Typography, Object.assign({ variant: "h5", color: "textPrimary" }, { children: "Nenhum question\u00E1rio encontrado" })) })) })) })) })))] })));
};

export { Quiz };
